export default __webpack_public_path__ + "static/media/electronic_payroll.61bb3578.svg";